<template>
  <div >
    <!-- <h1 class="title">{{ title }}</h1> -->
    <canvas id="canvas" ></canvas>
    <center>
    </center>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      title: 'Welcome,this is JIAMID\'s index.',
    }
  },
  mounted() {
    this.runCanvas();
  },

  methods:{
    runCanvas:function(){
      var canvas=document.getElementById("canvas");
      canvas.width = document.documentElement.clientWidth;
      canvas.height = document.documentElement.clientHeight;
      var can=canvas.getContext("2d");
      var w = canvas.width;
      var h = canvas.height;
      //can.fillStyle=randomColor();
      var words = Array(256).join("1").split("");
      var text = '';
      var x = 0;
      setInterval(draw,55);
      function draw(){
      	can.fillStyle='rgba(0,0,0,0.05)';
      	can.fillRect(0,0,w,h);
      	can.fillStyle=rgbColor();
      	words.map(function(y,n){
      		y=y+10;
      		if(n%2==0){
      			// text=String.fromCharCode(Math.ceil(65+Math.random()*57));
      			text='';
      		}else{
            text ='偲';
      		}

      		x = n*10;
      		can.fillText(text,x,y)
      		words[n]=( y > 758 + Math.random()*484 ? 0:y+10 );
      	});
      }
      function randomColor(){
      	return "#" + (function(color){
      		return new Array(7-color.length).join("0")+color;
      	})((Math.random()*0x1000000 << 0).toString(16))
      }

      function randomNum(m, n) {
        return Math.floor(Math.random() * (n - m + 1) + m);
      }
      function rgbColor() {
        return "rgb(" + randomNum(0, 255) + "," + randomNum(0, 255) + "," + randomNum(0, 255) + ")";
      }
    },
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main{
    position: fixed;
    text-align: center;
  }
  #canvas{
      width: 100%;
      height: auto;
      display: inline-block;
      vertical-align: baseline;
      position: fixed;
      z-index: -2;
      top: 0rem;
      left: 0rem;
  	}
  .jiamid{
    position: fixed;
    text-align: center;
    top:10%;
    font-family: "arial black";
    font-weight: bold;
    font-size: 16rem;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue